import React from "react";
import { connect } from "react-redux";
import language from "./../dictionary/index";
import { setLanguage, setNetwork } from "./../redux/actions/commonAction";

class AppBar extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
    
        <div style={{backgroundColor:this.props.network == "live"? "rgb(6, 27, 55)": "rgb(237,68,84)",padding : '2em 1em' , display:'flex' , flexDirection :'column' }}>
          {/* <div style={{width : '100%', display: 'flex', flexDirection:'row-reverse' , justifyContent : 'space-between' , alignItems :'flex-start'}}>
              <div style={{display: 'flex', flexDirection:'row-reverse' , alignItems :'center'}}>
                <img style={{width : '6em' , backgroundColor : 'hsla(0,0%,100%,.8)', padding : '1em' , borderRadius : 10}} src={__dirname + "public/img/kuknos.png"} />
                <div  style={{marginRight : 20 , textAlign :'right' , fontSize: '1.7em', color : '#fff'}}>
                  {language.KuknosNetwork[this.props.language]}
                </div>
              </div>


              <div className="back">
                <a href="https://www.kuknus.org">&laquo; Kuknus.org</a>
              </div>
          </div> */}

          <div style={{width : '100%', display: 'flex', flexDirection: 'roe', justifyContent :'space-between' , marginTop: 0 , marginRight: 30}}>
            <div  style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start" , flexWrap  :'wrap'}}>
              
              <div style={{width : 80 , height:40, display :'flex' , justifyContent:'center', alignItems:'center',backgroundColor:this.props.language == "english"? "#1972e6": "transparent",cursor: "pointer",borderRadius: 8,}} onClick={() => {this.props.setLanguage("english");}} >
                <p style={{fontSize: 11, marginTop : 7 , color : '#fff'}} >
                  English
                </p>
              </div>
              <div style={{width : 80, height:40, display :'flex' , justifyContent:'center', alignItems:'center' , backgroundColor:this.props.language == "persian"? "#1972e6" : "transparent",cursor: "pointer",borderRadius: 8,}} onClick={() => {this.props.setLanguage("persian"); }}>
                <p style={{fontSize: 11 , marginTop : 7, color : '#fff'}} >
                  فارسی
                </p>
              </div>
    
            </div>
            

            <div style={{display: "flex", flexDirection: "row",justifyContent: "flex-start",marginBottom :-20 , flexWrap  :'wrap'}}>
              
              <div style={{width : 80, height:40 , display :'flex' , justifyContent:'center', alignItems:'center',backgroundColor:this.props.network == "test"? "#1972e6": "transparent",cursor: "pointer",borderRadius: 8,}} onClick={() => {this.props.setNetwork("test")}} >
                <p style={{fontSize: 11 , marginTop : 7, color : '#fff'}} >
                  شبکه تست  
                </p>
              </div>
              <div style={{width : 80, height:40 , display :'flex' , justifyContent:'center', alignItems:'center' , backgroundColor:this.props.network == "live"? "#1972e6" : "transparent",cursor: "pointer",borderRadius: 8,}} onClick={() => {this.props.setNetwork("live"); }} >
                <p style={{fontSize: 11, marginTop : 7 , color : '#fff'}}>
                  شبکه اصلی
                </p>
              </div>

              

            </div>

          </div>
    

        </div>




      </div>
    );
  }
}

const mapSateToProps = ({ CommonReducer }) => {
  return {
    language: CommonReducer.language,
    network: CommonReducer.network,
  };
};

export default connect(
  mapSateToProps,
  { setLanguage, setNetwork },
)(AppBar);



// WEBPACK FOOTER //
// ./frontend/components/AppBar.js